import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { loading: "Cargando…" },
  en: { loading: "Loading…" },
});
